var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v("404 Page Missing")]),_vm._v(" "),_c('article',{staticClass:"notification is-danger"},[_c('p',[_vm._v("Sorry, we can't seem to find the page you are looking for.")])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93a6df98","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error404.vue
// module id = 366
// module chunks = 1